module.exports = __webpack_public_path__ + "img/akupara.eb24c6ba.png";